import React from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Accordion,
  Tab,
  Tabs,
} from "react-bootstrap";
import {
  FaFilePdf,
  FaRegNewspaper,
  FaChartLine,
  FaUserMd,
  FaHandHoldingHeart,
} from "react-icons/fa";
import "./ResearchPage.css";
import MyFooter from "./MyFooter";
import { Link } from "react-router-dom";

const ResearchPage = () => {
  // Sample research data
  const featuredStudies = [
    {
      id: 1,
      title:
        "Twenty years of home-based palliative Care in Malappuram, Kerala, India: a descriptive study of patients and their care-givers",
      authors:
        "Rekha Rachel Philip1*, Sairu Philip1, Jaya Prasad Tripathy2, Abdulla Manima3 and Emilie Venables4,5",
      journal: "BMC Palliativecare",
      date: "2018",
      image:
        "https://images.unsplash.com/photo-1576091160550-2173dba999ef?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80",
      summary:
        "The well lauded community-based palliative care programme of Kerala, India provides medical and social support, through home-based care, for patients with terminal illness and diseases requiring long-term support.There is, however, limited information on patient characteristics, caregivers and programme performance. This study was carried out to describe: i) the patients enrolled in the programme from 1996 to 2016 and their diagnosis, and ii) the care-giver characteristics and palliative care support from nurses and doctors in a cohort of patients registered during 2013–2015.",
      link: "#",
      impact:
        "The need for similar programmes to remain flexible and adapt their services in response to a growing global burden ofNon Communicable DiseasesChanged clinical practice guidelines worldwide",
      fname: "research1.pdf",
    },
    {
      id: 2,
      title:
        "Poisedness for social innovation: The genesis and propagation of communitybased palliative care in Kerala (India)",
      authors: "Devi Vijay, Philippe Monin",
      journal: "Palliative Medicine",
      date: "2021",
      image:
        "https://images.unsplash.com/photo-1581056771107-24ca5f033842?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80",
      summary:
        "When and where do social innovations emerge? We address this question using comparative and historical analyses of organizing for palliative care in India. Although palliative care made in-roads into different parts of India in the 1980s, it evolved as a vibrant sector only in the state of Kerala, through a novel community-based approach. By examining historical and social conditions, we reveal how poisedness, and particularly political poisedness, of time and place manifests in the genesis and propagation of a social innovation. We contribute to the literature on macro-foundations of social innovations by illustrating how an array of organizations and individuals create the very conditions of poisedness that are thereafter leveraged by institutional actors for the construction of novelty and propagation. Moreover, we specify the conditions of poisedness that are conducive to propagation, thereby contributing to conversations on distinct phases of emergence.",
      link: "#",
      impact:
        "As Padgett and Powell (2012: 2) note: “organizational genesis does not mean virgin birth”. We traced the origins of palliative care in Kerala back to 1993 and examined how a novel community-based model for palliative care emerged as a deviation from the prevailing, legitimized professional-driven approaches. We explained how poisedness is instantiated in emergence and how the very conditions of poisedness are created by an array of organizations and individuals. Our research calls for explicit attention to socio-historical processes, often absent from studies of social innovations. Our comparative historical analyses of attempts at replicating the innovation outside Kerala highlight how equality of agency may be a problematic assumption and how equality of opportunity needs to be examined to understand actors’ organizational capabilities across social contexts.!",
      fname: "research2.pdf",
    },
  ];

  const clinicalStudies = [
    {
      id: 3,
      title: "Effect of Palliative Care on Hospital Readmissions",
      authors: "Smith S, Brick A, O'Hara S, Normand C",
      journal: "JAMA Internal Medicine",
      date: "2022",
      summary:
        "Multicenter study demonstrating 30% reduction in 30-day readmissions for patients receiving inpatient palliative care consultation.",
      link: "#",
    },
    {
      id: 4,
      title: "Telehealth in Rural Palliative Care",
      authors: "Johnston B, Kidd L, Wengstrom Y, Kearney N",
      journal: "Journal of Telemedicine and Telecare",
      date: "2021",
      summary:
        "Randomized controlled trial showing non-inferiority of telehealth palliative care visits for pain management in rural populations.",
      link: "#",
    },
  ];

  const psychosocialResearch = [
    {
      id: 5,
      title: "Dignity Therapy in Terminal Illness",
      authors: "Chochinov HM, Hack T, Hassard T, et al.",
      journal: "Journal of Clinical Oncology",
      date: "2020",
      summary:
        "Novel intervention demonstrating significant reductions in depressive symptoms and improved sense of meaning for terminally ill patients.",
      link: "#",
    },
    {
      id: 6,
      title: "Cultural Variations in End-of-Life Decision Making",
      authors: "Kwak J, Haley WE, Chiriboga DA",
      journal: "The Gerontologist",
      date: "2022",
      summary:
        "Cross-cultural comparison of treatment preferences and advance care planning in diverse ethnic groups.",
      link: "#",
    },
  ];

  const researchResources = [
    {
      title: "Research Publications",
      icon: <FaRegNewspaper className="resource-icon" />,
      description:
        "Access our complete library of published research articles and clinical studies",
      link: "#",
    },
    {
      title: "Clinical Guidelines",
      icon: <FaUserMd className="resource-icon" />,
      description:
        "Evidence-based practice guidelines for palliative care professionals",
      link: "#",
    },
    {
      title: "Patient Outcomes Data",
      icon: <FaChartLine className="resource-icon" />,
      description:
        "Annual reports on quality metrics and patient/family satisfaction",
      link: "#",
    },
  ];

  return (
    <div data-aos="fade-up" className="research-page">
      {/* Hero Banner */}
      <section className="research-hero bg-primary text-white py-5">
        <Container>
          <Row>
            <Col lg={8} className="mx-auto text-center">
              <h1 className="display-4 mb-3">
                Advancing Palliative Care Through Research
              </h1>
              <p className="lead">
                Conduct research on community palliative care to enhance
                services for society. Collaborate with government,
                non-governmental agencies, and research experts to drive
                impactful studies.
              </p>
            </Col>
          </Row>
        </Container>
      </section>
<section className="py-5">

  <h6 className="text-center py-72">No Research Documents Available</h6>
</section>
      {/* Featured Research
      <h2 className="text-center mb-5">Featured Studies</h2>
      <section className="py-5">
        <Container>
          <Row>
            {featuredStudies.map((study) => (
              <Col lg={6} key={study.id} className="mb-4">
                <Card className="h-100 shadow-sm featured-study-card">
                  <div className="featured-image-container">
                    <Card.Img className="img-research"
                      variant="top"
                      src={study.image}
                      alt={study.title}
                    />
                  </div>
                  <Card.Body>
                    <Card.Title>{study.title}</Card.Title>
                    <Card.Subtitle className="mb-2 text-muted">
                      {study.authors} | {study.journal} | {study.date}
                    </Card.Subtitle>
                    <Card.Text>{study.summary}</Card.Text>
                    <div className="study-impact mb-3">
                      <FaHandHoldingHeart className="text-primary me-2" />
                      <strong>Clinical Impact:</strong> {study.impact}
                    </div>
                    <Link to={`/pdfviewer/${encodeURIComponent(study.fname)}`}>
                      <Button variant="primary" className="me-2">
                        Read Study
                      </Button>
                    </Link>

                    <Link to={`/pdfviewer/${encodeURIComponent(study.fname)}`}>
                      <Button variant="outline-primary">
                        <FaFilePdf className="me-1 text-danger" /> Download PDF
                      </Button>
                    </Link>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
       */}
    </div>
  );
};

export default ResearchPage;
